import React, { useEffect, useState } from "react";
import {
  Box,
  Input,
  Text,
  Button,
  Flex,
  useToast,
  Spinner,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  useDisclosure,
} from "@chakra-ui/react";
import axios from "axios";
import { Link as RouterLink } from "react-router-dom";
import { Link as ChakraLink } from "@chakra-ui/react";
import { EditIcon, DeleteIcon } from "@chakra-ui/icons";
import Navbar from "../Navbar/Navbar";
import Sidebar from "../Sidebar";
import * as mod from "../../url";

const storedData = JSON.parse(sessionStorage.getItem("superAdminLawvs"));
const token = storedData?.data?.token;
const config = { headers: { Authorization: `${token}` } };
const SIDEBAR_WIDTH = "250px";

export const CreateAwardsCategory = () => {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [categoryName, setCategoryName] = useState("");
  const [eligibility, setEligibility] = useState("");
  const [allCategory, setAllCategory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [selectedCat, setSelectedCat] = useState(null);
  const [editName, setEditName] = useState("");

  /* ================= FETCH ALL ================= */
  const getAllCategory = async () => {
    try {
      const { data } = await axios.get(
        `${mod.api_url}/api/v1/superAdmin/get_all_election_category`
      );
      setAllCategory(data?.data || data);
    } catch (error) {
      toast({
        title: "Failed to load categories",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllCategory();
  }, []);

  /* ================= CREATE ================= */
  const handleSubmit = async () => {
    if (!categoryName.trim()) {
      toast({
        title: "Category name required",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      await axios.post(
        `${mod.api_url}/api/v1/superAdmin/create_election_category`,
        {
          name: categoryName,
          des: eligibility,
        },
        config
      );

      toast({
        title: "Category Created",
        description: "Award category added successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      setCategoryName("");
      setEligibility("");
      getAllCategory();
    } catch (error) {
      toast({
        title: "Creation failed",
        description: error.response?.data?.message || "Something went wrong",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  /* ================= UPDATE ================= */
  const openEditModal = (cat) => {
    setSelectedCat(cat);
    setEditName(cat.name);
    onOpen();
  };

  const handleUpdate = async () => {
    if (!editName.trim()) return;

    setUpdating(true);
    try {
      await axios.put(
        `${mod.api_url}/api/v1/superAdmin/update_election_category/${selectedCat._id}`,
        { name: editName },
        config
      );

      toast({
        title: "Category Updated",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      onClose();
      getAllCategory();
    } catch (error) {
      toast({
        title: "Update failed",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setUpdating(false);
    }
  };

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this category?"))
      return;

    try {
      await axios.delete(
        `${mod.api_url}/api/v1/superAdmin/delete_election_category/${id}`,
        config
      );

      toast({
        title: "Category Deleted",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      getAllCategory();
    } catch (error) {
      toast({
        title: "Delete failed",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  /* ================= UI ================= */
  return (
    <>
      <Navbar />
      <Sidebar />

      <Box mt="90px" ml={{ base: 0, md: SIDEBAR_WIDTH }} p={4} bg="gray.50">
        {/* CREATE FORM */}
        <Box
          maxW="1000px"
          mx="auto"
          bg="white"
          p={6}
          borderRadius="md"
          boxShadow="md"
          mb={8}
        >
          <Text fontSize="2xl" mb={4} bg="#D29B3F" p={3} color="white">
            Add Awards Category
          </Text>

          <Input
            placeholder="Enter Award Title"
            mb={4}
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
          />

          <Input
            placeholder="Who is eligible for this award?"
            mb={4}
            value={eligibility}
            onChange={(e) => setEligibility(e.target.value)}
          />

          <Flex justify="flex-end" gap={4}>
            <Button
              variant="ghost"
              onClick={() => {
                setCategoryName("");
                setEligibility("");
              }}
            >
              Cancel
            </Button>
            <Button colorScheme="green" onClick={handleSubmit}>
              Submit
            </Button>
          </Flex>
        </Box>

        {/* LIST */}
        <Box
          maxW="1000px"
          mx="auto"
          bg="white"
          p={6}
          borderRadius="md"
          boxShadow="md"
        >
          <Text fontSize="sm" mb={2} textAlign="right">
            Total Records: {allCategory.length}
          </Text>

          {loading ? (
            <Spinner size="xl" />
          ) : (
            <Table variant="simple" size="sm">
              <Thead bg="gray.100">
                <Tr>
                  <Th>#</Th>
                  <Th>Title</Th>
                  {/* <Th>Date</Th> */}
                  <Th>Update</Th>
                  <Th>Delete</Th>
                </Tr>
              </Thead>
              <Tbody>
                {allCategory.map((cat, index) => (
                  <Tr key={cat._id}>
                    <Td>{index + 1}</Td>
                    <Td>
                      <ChakraLink
                        // as={RouterLink}
                        // to={`/single-cat/${cat.slug}`}
                        color="blue.500"
                        fontWeight="medium"
                      >
                        {cat.name}
                      </ChakraLink>
                    </Td>
                    <Td>
                      <ChakraLink
                        // as={RouterLink}
                        // to={`/single-cat/${cat.slug}`}
                        color="blue.500"
                        fontWeight="medium"
                      >
                        {cat.des}
                      </ChakraLink>
                    </Td>
                    {/* <Td>
                      {new Date(cat.createdAt).toLocaleDateString("en-IN")}
                    </Td> */}
                    <Td>
                      <IconButton
                        icon={<EditIcon />}
                        size="sm"
                        colorScheme="blue"
                        onClick={() => openEditModal(cat)}
                      />
                    </Td>
                    <Td>
                      <IconButton
                        icon={<DeleteIcon />}
                        size="sm"
                        colorScheme="red"
                        onClick={() => handleDelete(cat._id)}
                      />
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          )}
        </Box>
      </Box>

      {/* EDIT MODAL */}
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Update Category</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Input
              value={editName}
              onChange={(e) => setEditName(e.target.value)}
              placeholder="Enter category name"
            />
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={handleUpdate}
              isLoading={updating}
            >
              Update
            </Button>
            <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
